/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useQuery } from '@apollo/client';

import { TeamMembershipRolePermissions } from '@fai/friendli-suite/features/common/team-membership-role';
import { TeamRoleDocument } from '@fai/friendli-suite/generated/client/graphql';

export const useTeamRole = (teamId: string) => {
  const {
    data: rawData,
    loading,
    error,
  } = useQuery(TeamRoleDocument, {
    variables: { teamId },
    fetchPolicy: 'cache-and-network',
  });

  const teamRole = rawData?.clientSession?.user.team?.role;

  return {
    teamRole,
    isTeamOwner: TeamMembershipRolePermissions(teamRole).isAboveAdmin,
    loading,
    error,
  };
};
